<template>
  <div id="app" class="app-root">
    <router-view />
  </div>
</template>

<script>
export default { name: 'App' }
</script>

<style>
html,
body,
#app,
.app-root {
  height: 100%;
  margin: 0;
}
</style>
